import AsoHeader from "../../../components/Aso/Header";
import AsoContinuar from "../../../components/Aso/Register/AsoContinuar";

const RegistroContinuarEmpresa = () => {

    return (
        <div>
            <AsoHeader />
            <AsoContinuar />
        </div>
    );
}

export default RegistroContinuarEmpresa;